<ion-item button="true" class="border border-radius margin-all-small">
    <lib-svg-icon
        [backgroundColor]="'color-mix(in srgb, var(--ion-color-orange) 10%, transparent)'"
        [borderSpacing]="10"
        [color]="'var(--ion-color-orange)'"
        [iconName]="leftIconName()"
        [roundBorder]="true"
        [size]="24"
        borderColor="transparent"
        color="orange"
        slot="start" />

    <ion-label>
        <ion-text class="font-500">{{ text() }}</ion-text>
        <br />
        <ion-note>{{ note() }}</ion-note>
    </ion-label>

    <lib-svg-icon [color]="'var(--ion-color-black)'" [iconName]="rightIconName()" [size]="24" slot="end" />
</ion-item>
